import React from "react";
import { i18n } from "../../translate/i18n";

const ModalStepThree = ({ columns, contacts }) => (
	<div className="app-import-step-content space-y-4">
		<p className="m-0 text-sm text-default-600 dark:text-default-400">
			{i18n.t("contactsImportModal.stepThree.intro")}
		</p>

		<div className="overflow-x-auto rounded-md border border-default-200 dark:border-default-700">
			<table className="min-w-full divide-y divide-default-200 dark:divide-default-700">
				<thead className="bg-default-150 dark:bg-default-800/60">
					<tr className="text-sm font-normal text-default-700 dark:text-default-300">
						<th scope="col" className="px-3.5 py-3 text-start">
							{i18n.t("contacts.table.name")}
						</th>
						<th scope="col" className="px-3.5 py-3 text-start">
							{i18n.t("contacts.table.whatsapp")}
						</th>
						{columns.email !== "" && (
							<th scope="col" className="px-3.5 py-3 text-start">
								{i18n.t("contacts.table.email")}
							</th>
						)}
					</tr>
				</thead>
				<tbody className="divide-y divide-default-200 dark:divide-default-700">
					{contacts.map((contact, index) => (
						<tr
							key={`${contact[columns.name]}-${index}`}
							className="text-sm text-default-800 dark:text-default-200"
						>
							<td className="whitespace-nowrap px-3.5 py-2.5">{contact[columns.name]}</td>
							<td className="whitespace-nowrap px-3.5 py-2.5">{contact[columns.number]}</td>
							{columns.email !== "" && (
								<td className="whitespace-nowrap px-3.5 py-2.5">
									{contact[columns.email]}
								</td>
							)}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	</div>
);

export default ModalStepThree;
